import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationModels } from '@wz-models';
import { Observable } from 'rxjs';
import { ApiServiceBase, NpsReponse } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class NpsApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'Nps');
  }

  getQuestions(): Observable<NpsQuestions[]> {
    return this.getNpsQuestions('/questions');
  }

  getClientQuestions(): Observable<NpsQuestions[]> {
    var type: string = 'client';
    return this.getNpsQuestionsByType('/questions/' + type);
  }
  getProspectQuestions(): Observable<NpsQuestions[]> {
    var type: string = 'prospect';
    return this.getNpsQuestionsByType('/questions/' + type);
  }

  saveNote(request: number) {
    return this.post('/scoring', request);
  }

  saveReponse(request: NpsReponse) {
    return this.post('/reponse', request);
  }
}

interface NpsQuestions {
  id: number;
  questionLabel: string;
  questionType: string;
}
